import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { useForm, Controller } from 'react-hook-form'
import { NotificationManager } from 'react-notifications'
import { DateTime } from 'luxon'
import { answerTicket } from '../../../../http/ticket'
import css from './styles.module.scss'
import WYSIWYGEditor from '../../../../components/common/WYSIWYG'
import { formatCellPhone } from '../../../../util/utils'

export default function ModalTicket({ show, handleClose, ticket, setLoading, editable }) {
  const {
    handleSubmit, setValue, reset, getValues, control,
  } = useForm()

  useEffect(() => {
    const fields = ['answer']
    if (ticket.id) {
      fields.forEach((field) => setValue(field, ticket[field]))
      return
    }
    fields.forEach((field) => setValue(field, null))
  }, [ticket, setValue])

  const onSubmit = async (data) => {
    setLoading(true)
    answerTicket(ticket.id, data.answer).then(e => {
      NotificationManager.success('A resposta foi salva com sucesso', 'Salvo com sucesso')
      close()
    }).catch((e) => {
      NotificationManager.error('Erro no servidor', 'Ocorreu um erro')
    }).finally(e => {
      setLoading(false)
    })
  }

  const close = () => {
    reset()
    handleClose()
  }
  
  return (
    <Modal
      show={show}
      onHide={close}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      dialogClassName={css['dialog']}
    >
      <Modal.Header closeButton>
        <Modal.Title>Responder ticket</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <p><b>Requisitante:</b> {ticket.user?.name} ({ticket.user?.email} | { formatCellPhone(ticket.user)} )</p>
          <p><b>Assunto:</b> {ticket.title}</p>
          <p><b>Criado em:</b> {DateTime.fromJSDate(new Date(ticket.createdAt)).toFormat("dd/M/yyyy HH:mm")}</p>
          {ticket.message && <p><b>Descrição:</b> {ticket.message}</p>}
          {ticket.updatedAt !== ticket.createdAt &&
            <p><b>Respondido em:</b> {DateTime.fromJSDate(new Date(ticket.updatedAt)).toFormat("dd/M/yyyy HH:mm")}</p>
          }

          {ticket.answer && 
            <p><b>Reposta:</b> <span dangerouslySetInnerHTML={{__html: ticket.answer}}></span></p>
          }
          
          <Form.Group className="mb-3">
            <Form.Label><b>Resposta</b></Form.Label>
            {editable ? (
            <Controller
              render={ () => 
                <WYSIWYGEditor 
                  value={getValues('answer')}
                  onChange={value => {
                    setValue('answer', value)
                  }} 
                /> 
              }
              name='answer'
              control={control}
              //defaultValue=''
            />) : (
              <span dangerouslySetInnerHTML={{__html: ticket.answer}}></span>
            )
          }
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close}>
            {editable ? "Cancelar" : "Fechar" }
          </Button>
          {editable ? <Button type="submit" variant="success">Responder</Button> : null}
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
